export enum PredefinedHostType {

    CANVAS = "Canvas",

    PANEL = "Panel",
}
